import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { ConfluenceAccumulatedDataType } from './confluence-accumulated-data-type';

/**
 * Data payload for creating a Confluence whiteboard.
 */
export type ConfluenceCreateWhiteboardData = ConfluenceAccumulatedDataType & {
	/**
	 * The title to be included in the created whiteboard.
	 */
	title: string;
	/**
	 * The svg to be included in the created whiteboard.
	 */
	document: string;
};

/**
 * Properties for the Confluence whiteboard creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceCreateWhiteboardCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the whiteboard creation request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the new whiteboard.
	 */
	data: ConfluenceCreateWhiteboardData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to create a new Confluence whiteboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence whiteboard with the specified content.
 */
export const ConfluenceWhiteboardCreateCommand =
	createCommand<ConfluenceCreateWhiteboardCommandProperties>(
		'confluence-whiteboard-create-command',
	);
